// extracted by mini-css-extract-plugin
export var cardHeader = "_hh-0";
export var reorderHandle = "_hh-3";
export var titleArea = "_hh-1";
export var titleAreaWithHandle = "_hh-2";